import AppBar from '@mui/material/AppBar';

import { styled } from '@mui/material/styles';
export const StyledAppBar = styled(AppBar)`
  margin-top: 1rem;
`;

export const StyledLoading = styled('div')`
  display: flex;
  justify-content: center;
`;
